module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAASklEQVQ4y2P4jwQ+MAww7wADDNgPPI///38G+/9/BgcPyGDgHyQ8oMsYwM4bBDyQo1BCaQB5IJcxMP8fLDwgg2Ew8AZRnh48ZR0AyXm0lUUEHQcAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6MjY6NDMrMDk6MDB5Ddv1AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjI2KzA5OjAwy+cM3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00325_100x100.png
// module id = 5CAy
// module chunks = 0